"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactQuery = require("react-query");
var _reactI18next = require("react-i18next");
var _axios = _interopRequireDefault(require("axios"));
var _themeTeaser = _interopRequireDefault(require("../theme-teaser"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const TopMenuTeaser = _ref => {
  var _items;
  let {
    providers
  } = _ref;
  const {
    REACT_APP_PATH,
    REACT_APP_PROVIDER_ID
  } = process.env;
  const {
    i18n
  } = (0, _reactI18next.useTranslation)();
  const url = "".concat(REACT_APP_PATH, "/Micado.Tourism.Web/Micado.Tourism.Web.IO.Api.ProviderApi/ListMenus.api?providers=").concat(providers ? providers : REACT_APP_PROVIDER_ID, "&lang=").concat(i18n.language);
  const {
    data,
    status
  } = (0, _reactQuery.useQuery)(["list-menus", i18n.language, providers], () => _axios.default.get(url));
  const formatData = (data, providers) => {
    if (!data) {
      return [];
    }
    return data.reduce((res, item) => {
      if (item.top) {
        var _item$media;
        res.push({
          teaser: {
            addition: item === null || item === void 0 ? void 0 : item.addition,
            id: item === null || item === void 0 ? void 0 : item.id,
            link: "/".concat(i18n.language, "/cuisine/").concat(item === null || item === void 0 ? void 0 : item.id).concat(providers ? "?providers=".concat(providers) : ""),
            media: (_item$media = item === null || item === void 0 ? void 0 : item.media) !== null && _item$media !== void 0 ? _item$media : [],
            title: item === null || item === void 0 ? void 0 : item.title,
            from: item === null || item === void 0 ? void 0 : item.dateFrom,
            to: item === null || item === void 0 ? void 0 : item.dateTo
          }
        });
      }
      return res;
    }, []);
  };
  let items = [];
  if (status === "success") {
    items = formatData(data === null || data === void 0 ? void 0 : data.data, providers);
  }
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, (_items = items) === null || _items === void 0 ? void 0 : _items.map(item => {
    const {
      id
    } = item === null || item === void 0 ? void 0 : item.teaser;
    return /*#__PURE__*/_react.default.createElement(_themeTeaser.default, {
      data: item,
      key: id,
      mediaFormat: "meal-theme-teaser"
    });
  }));
};
var _default = exports.default = TopMenuTeaser;